(function () {
  function initStory(section) {
    var text = section.querySelector('[data-bayaan-story-text]');
    var btn = section.querySelector('[data-bayaan-story-more]');
    if (!text || !btn || btn.dataset.bound === 'true') return;
    btn.dataset.bound = 'true';

    var mq = window.matchMedia('(max-width: 749px)');

    function sync() {
      if (!mq.matches) {
        text.classList.remove('is-expanded');
        btn.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = 'Read more';
        return;
      }

      text.classList.remove('is-expanded');
      var needsToggle = text.scrollHeight > text.clientHeight + 8;
      text.classList.toggle('is-expanded', btn.getAttribute('aria-expanded') === 'true');

      if (btn.getAttribute('aria-expanded') === 'true') {
        btn.hidden = false;
        btn.textContent = 'Read less';
        return;
      }

      btn.hidden = !needsToggle;
      btn.textContent = 'Read more';
    }

    btn.addEventListener('click', function () {
      var expanded = text.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      btn.textContent = expanded ? 'Read less' : 'Read more';
    });

    sync();
    mq.addEventListener('change', sync);
    window.addEventListener('load', sync);
  }

  function initAll() {
    document.querySelectorAll('[data-bayaan-story]').forEach(initStory);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-bayaan-story]');
    if (section) initStory(section);
  });
})();
